import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useMemo } from "react";

import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

// ✅ easy toggles for agent menu visibility
const AGENT_CAN_SEE_CLIENTS = true;   // <== بدّليها حسب اختيارك
const AGENT_CAN_SEE_SERVICES = true;  // <== بدّليها حسب اختيارك

const SidebarContent = (props) => {
  const ref = useRef();

  // ✅ role check (admin/agent) from localStorage
  const rawUser = localStorage.getItem("user") || localStorage.getItem("authUser");
  const currentUser = useMemo(() => {
    try {
      return rawUser ? JSON.parse(rawUser) : {};
    } catch {
      return {};
    }
  }, [rawUser]);

  const role = String(currentUser?.role || "").toLowerCase();
  const isAdmin = role === "admin";
  const isAgent = role === "agent";

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;

          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;

            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;

        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    if (!ul) return;

    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current?.recalculate?.();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item && ref.current?.getScrollElement) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")}</li>

            {/* ✅ Dashboard (admin + agent) */}
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* ✅ Reservations (admin + agent) */}
            <li>
              <Link to="/reservations" className="waves-effect">
                <i className="mdi mdi-calendar-check"></i>
                <span>Réservations</span>
              </Link>
            </li>

            {/* ✅ Services (admin always, agent optional) */}
            {(isAdmin || (isAgent && AGENT_CAN_SEE_SERVICES)) && (
              <li>
                <Link to="/services" className="waves-effect">
                  <i className="mdi mdi-briefcase-outline"></i>
                  <span>Services</span>
                </Link>
              </li>
            )}

            {/* ✅ Clients (admin always, agent optional) */}
            {(isAdmin || (isAgent && AGENT_CAN_SEE_CLIENTS)) && (
              <li>
                <Link to="/clients" className="waves-effect">
                  <i className="mdi mdi-account-multiple-outline"></i>
                  <span>Clients</span>
                </Link>
              </li>
            )}

           
            {/* ✅ admin only */}
            {isAdmin && (
              <li className="menu-title mt-3">{props.t("Admin")}</li>
            )}

            {isAdmin && (
              <li>
                <Link to="/agents" className="waves-effect">
                  <i className="mdi mdi-account-badge-outline"></i>
                  <span>Agents</span>
                </Link>
              </li>
            )}

            {isAdmin && (
              <li>
                <Link to="/whatsapp" className="waves-effect">
                  <i className="mdi mdi-whatsapp"></i>
                  <span>WhatsApp Connect</span>
                </Link>
              </li>
            )}

            {/* ✅ Subscription: you said bghiti blach => نخليها غير admin + تقدر تحيديها نهائيا */}
            {isAdmin && (
              <li>
                <Link to="/subscription" className="waves-effect">
                  <i className="bx bx-credit-card"></i>
                  <span>Subscription</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
